<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="c01"><a id="page2"></a><span href="#/OEBPS/toc#c1" title="Link target outside of Sample">1<br/><em>Breakfast</em></span></h1>
<p class="figure"><a id="page3"></a><img alt="" src="OEBPS/images/3-1.jpg"/></p>
<p class="chaptext">From steel-cut oats packed with berries to light and fluffy cinnamon-coated rolls, fried eggs over hash browns, and spicy charred sausage with avocado, breakfast casseroles come in all shapes and sizes.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c01.vue?89ea955c